import React, { Component } from 'react';
import styled from 'styled-components';

import EmailForm from '../PageComponents/EmailForm';
import ProductForm from '../PageComponents/ProductForm';
import Modal from  '../PageComponents/Modal';

const Pie = styled.div`
  
  .viewCart {
    border-top: solid 1px #ddd; 
    margin-top: 40px;
    padding: 15px 0 0 300px;
    position: relative;

  }
 
  .textSection {
    margin: 0 0 40px;
    width: 100%

    span.emailFormLink {
      color: #ffbf80;
      cursor: pointer;
      position: relative;
      
      > .emailForm {
        left: 0px;
        top: 20px; 
      }

    span.emailFormLink:hover {
      text-decoration: underline dotted;
    }
  }

`;


class Shop extends Component {
  
  constructor() {
    super();
    this.modalWindow = React.createRef();
  }
   
    state = {
      showContactDiv: false,
      showModal: false,
      modalImg: '',
      modalAltTxt: ''
    }

  handleContactDiv = () => {
    this.setState({ showContactDiv: !this.state.showContactDiv});
  };

  handleClick = (e) => {
    if(e.target.id !== 'emailForm'){
      this.setState({ showContactDiv: false } ,
        () => document.removeEventListener('click', this.handleClick, false)
      );
    }
  };

  handleModal = (img, alt) => {
    this.setState({
      modalImg: img,
      modalAltTxt: alt,
      showModal: true
    })
  };

  handleCloseModal = (e) => {
      this.setState({ showModal: false });
  }; 

    render() { 
      return (
        <Pie className="pageStyle">
          <div className="textSection">
              <p>I am happy to offer giclée prints of selected work, printed on 100% cotton archival Hahnemuhle Photo Rag paper. Transactions are handled through PayPal (a PayPal account isn't necessary). Normal delivery time is about 7-10 days. Please note that the holidays are a busy time for the printer and orders placed after December 10 may take 2 to 3 weeks to ship.</p>
              <p>A few original works are available. If you're interested in a specific piece <span className="emailFormLink" onClick={(e) => {
                    this.handleContactDiv(e);
                    document.addEventListener('click', this.handleClick, false);
                    e.stopPropagation();
                  }}>contact me{ this.state.showContactDiv && <EmailForm className="emailForm" /> }</span> for availability and price.</p>
          </div>
            <ProductForm 
              title="Talisman for Retrieving Lost Things"
              size="12&quot; x 12&quot;"
              price="$45"
              image="cetus.jpg"
              paypalID="UQ4DWCDDML3MN"
              handleModal={this.handleModal}  
            />
            <ProductForm 
              title="Siren's Tether"
              size="12&quot; x 12&quot;"
              price="$45"
              image="sirens_tether.jpg"
              paypalID="6R7PC3BE9X5ZJ" 
              handleModal={this.handleModal}  
            />
            <ProductForm 
              title="Talisman for Sight"
              size="12&quot; x 12&quot;"
              price="$45"
              image="talisman_for_sight.jpg"
              paypalID="3SL7E4XD3PDSU" 
              handleModal={this.handleModal}  
            />
            <div className="viewCart">
              <form target="paypal" action="https://www.paypal.com/cgi-bin/webscr" method="post" >
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input type="hidden" name="encrypted" value="-----BEGIN PKCS7-----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-----END PKCS7-----" />
                
                <button className="cartButton" title="PayPal - The safer, easier way to pay online!" name="submit">view cart</button> &nbsp; (returns to checkout)
                <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />

              </form>
            </div>
            { this.state.showModal && 
              <Modal
                src={this.state.modalImg}
                title={this.state.modalAltTxt}
                handleClose={this.handleCloseModal}
              />
            }
        </Pie>      
      );
    }
}


export default Shop;